import { Environment } from '@shared/interfaces/environment';
import { RoutesPath } from '@shared/enums/routes-path';
import { GlobalRoutesPath } from '@shared/enums/global-routes-path';
import { ArticleDetailRoutesPath } from '@vinanalyser/pages/articles/enums/article-detail-routes-path';

export const environment: Environment = {
  production: true,
  langs: {
    fr: {
      host: 'vinanalyser.com',
      langs: ['fr', 'en', 'es'],
      countryCode: ['fr'],
      defaultLang: 'fr',
      plate: {
        code: 'f',
        placeholder: 'AB-123-CD',
      },
      api: {
        url: 'https://api.vinanalyser.com',
      },
      google: {
        maps: {
          apiKey: 'AIzaSyD2fE0fYj7pcB_uCdY66T8co4PEZmVLe_4',
        },
      },
      sentry: {
        dsn: 'https://1ee8ee37cdbfb2f695a94d7cfe89f9ef@o4508637161783296.ingest.de.sentry.io/4508698694189136',
      },
      config: {
        name: 'Vinanalyser',
        test: false,
        subscription: {
          name: 'Vinanalyser pro',
          prices: {
            fixed: 0.99,
            subscription: 49.99,
          },
          credit: 15,
        },
        advices: [
          {
            rate: 4.7,
            vote: 2254,
          },
        ],
        company: {
          rcs: '207787318',
          vat: 'BG207787318',
          address: 'Barzaritsa Street, 4A, ap.16, 1618 Sofia, Bulgaria',
          name: 'SRS MEDIA LTD',
        },
        partners: [],
        payment: {
          logo: '/assets/favicon.png',
        },
      },
      routes: {
        [RoutesPath.SIGN_IN]: 'login',
        [RoutesPath.SIGN_UP]: 'create-account',
        [RoutesPath.UNSUBSCRIBE]: 'cancel-subscription',
        [RoutesPath.FORGOT_PASSWORD]: 'forgot-password',
        [RoutesPath.RESET_PASSWORD]: 'update-password',
        [RoutesPath.CONTACT]: 'support-contact',
        [RoutesPath.ARTICLES]: 'newsroom',
        [RoutesPath.LANDINGS]: 'landings/car-history',
        [RoutesPath.DASHBOARD]: 'user-panel',
        [RoutesPath.NOT_FOUND]: 'not-found',
        [RoutesPath.ABOUT]: 'about-us',
        [RoutesPath.PREVIEW]: 'report-preview',
        [RoutesPath.PAYMENT_INTENT]: 'start-payment',
        [RoutesPath.PAYMENT_VALIDATION]: 'verify-payment',
        [RoutesPath.LOADING]: 'loading-results',
        [RoutesPath.LOADING_PREVIEW]: 'preview-processing',
        [RoutesPath.COMPANY]: 'about-company',
        [RoutesPath.PARTNERS]: 'business-partners',
        [RoutesPath.AFFILIATE]: 'referral-program',
        [RoutesPath.LEASING]: 'car-leasing',
        [RoutesPath.INSURANCE]: 'vehicle-insurance',
        [RoutesPath.SSO]: 'dashlink',
        [RoutesPath.CAR_NOT_FOUND]: 'vehicle-not-found',
        [RoutesPath.SERVICE]: 'service-details',
        [RoutesPath.SERVICES]: 'vin-check',
        [RoutesPath.PRICING]: 'plans-and-pricing',
        [RoutesPath.TESTIMONIALS]: 'customer-feedback',
        [RoutesPath.COMPARE]: 'compare-options',
        [RoutesPath.GLOSSARY]: 'automotive-glossary',
        [RoutesPath.VIN]: 'vin-decoder',
        [RoutesPath.CAREERS]: 'work-with-us',
        [RoutesPath.GUIDE]: 'how-it-works',
        [RoutesPath.PRESS]: 'media-kit',
      },
      globalRoutes: {
        [GlobalRoutesPath.LEGAL_NOTICE]: 'legal-notice',
        [GlobalRoutesPath.PRIVACY_POLICY]: 'privacy-policy',
        [GlobalRoutesPath.REFUND_POLICY]: 'refund-policy',
        [GlobalRoutesPath.TERMS_AND_CONDITIONS]: 'terms-and-conditions',
        [GlobalRoutesPath.TERMS_OF_SALES]: 'terms-of-sales',
        [GlobalRoutesPath.FREQUENTLY_ASKED_QUESTIONS]: 'faq',
      },
      serviceRoutes: {},
      articleRoutes: {
        [ArticleDetailRoutesPath.UNDERSTANDING_VIN_WHAT_EVERY_CAR_BUYER_SHOULD_KNOW]:
          'understanding-vin-what-every-car-buyer-should-know',
        [ArticleDetailRoutesPath.IS_YOUR_CAR_AT_RISK_HOW_VIN_CHECKS_HELP_DETECT_STOLEN_VEHICLES]:
          'is-your-car-at-risk-how-vin-checks-help-detect-stolen-vehicles',
        [ArticleDetailRoutesPath.THE_FUTURE_OF_VIN_DECODING_HOW_AI_IS_SHAPING_VEHICLE_HISTORY_REPORTS]:
          'the-future-of-vin-decoding-how-ai-is-shaping-vehicle-history-reports',
        [ArticleDetailRoutesPath.FROM_SALVAGE_TITLES_TO_HIDDEN_DAMAGE_WHAT_YOUR_VEHICLE_HISTORY_REPORT_REVEALS]:
          'from-salvage-titles-to-hidden-damage-what-your-vehicle-history-report-reveals',
      },
    },
  },
};
